import { RooftopDamageType } from './types'

export interface RooftopDamageTypeCategory {
  id: string
  label: string
  types: RooftopDamageType[]
}

export const rooftopDamageCategories: RooftopDamageTypeCategory[] = [
  {
    id: 'surface-damage',
    label: 'Surface Damage',
    types: [
      {
        id: 'cuts-and-tears',
        label: 'Cuts / Tears',
        rooftopProperty: 'cutsAndTears',
      },
      { id: 'punctures', label: 'Punctures', rooftopProperty: 'punctures' },
      {
        id: 'abrasions-and-scuffing',
        label: 'Abrasions / Scuffing',
        rooftopProperty: 'abrasionsAndScuffing',
      },
      { id: 'cracks', label: 'Cracks', rooftopProperty: 'cracks' },
      {
        id: 'delamination',
        label: 'Delamination',
        rooftopProperty: 'delamination',
      },
      {
        id: 'alligatoring',
        label: 'Alligatoring',
        rooftopProperty: 'alligatoring',
      },
      {
        id: 'blisters-and-bubbles',
        label: 'Blisters / Bubbles',
        rooftopProperty: 'blistersAndBubbles',
      },
    ],
  },
  {
    id: 'moisture-related-defects',
    label: 'Moisture-Related Defects',
    types: [
      {
        id: 'wet-insulation',
        label: 'Wet Insulation',
        rooftopProperty: 'wetInsulation',
      },
      {
        id: 'moisture-intrusion-water-ponding',
        label: 'Moisture Intrusion / Water Ponding',
        rooftopProperty: 'moistureIntrusionWaterPonding',
      },
      {
        id: 'capillary-moisture-intrusion',
        label: 'Capillary Moisture Intrusion',
        rooftopProperty: 'capillaryMoistureIntrusion',
      },
      {
        id: 'condensation-damage',
        label: 'Condensation Damage',
        rooftopProperty: 'condensationDamage',
      },
      {
        id: 'efflorescence',
        label: 'Efflorescence',
        rooftopProperty: 'efflorescence',
      },
    ],
  },
  {
    id: 'structural-issues',
    label: 'Structural Issues',
    types: [
      {
        id: 'depressions-low-spots',
        label: 'Depressions / Low Spots',
        rooftopProperty: 'depressionsLowSpots',
      },
      {
        id: 'sagging-deck-substrate',
        label: 'Sagging Deck / Substrate',
        rooftopProperty: 'saggingDeckSubstrate',
      },
      {
        id: 'open-or-unstable-joints',
        label: 'Open or Unstable Joints',
        rooftopProperty: 'openOrUnstableJoints',
      },
      {
        id: 'delaminated-layers-core-separation',
        label: 'Delaminated Layers / Core Separation',
        rooftopProperty: 'delaminatedLayersCoreSeparation',
      },
      {
        id: 'deformation-of-roof-surface',
        label: 'Deformation of Roof Surface',
        rooftopProperty: 'deformationOfRoofSurface',
      },
      {
        id: 'warped-or-bowed-panels',
        label: 'Warped or Bowed Panels',
        rooftopProperty: 'warpedOrBowedPanels',
      },
    ],
  },
  {
    id: 'fasteners-and-flashings',
    label: 'Fasteners and Flashings',
    types: [
      {
        id: 'backed-out-fasteners',
        label: 'Backed-Out Fasteners',
        rooftopProperty: 'backedOutFasteners',
      },
      {
        id: 'missing-fasteners',
        label: 'Missing Fasteners',
        rooftopProperty: 'missingFasteners',
      },
      {
        id: 'corroded-or-rusted-fasteners',
        label: 'Corroded or Rusted Fasteners',
        rooftopProperty: 'corrodedOrRustedFasteners',
      },
      {
        id: 'improperly-sealed-fasteners',
        label: 'Improperly Sealed Fasteners',
        rooftopProperty: 'improperlySealedFasteners',
      },
      {
        id: 'loose-or-detached-flashing',
        label: 'Loose or Detached Flashing',
        rooftopProperty: 'looseOrDetachedFlashing',
      },
      {
        id: 'cracked-sealant-at-flashing',
        label: 'Cracked Sealant at Flashing',
        rooftopProperty: 'crackedSealantAtFlashing',
      },
      {
        id: 'improper-counterflashing-step-flashing-installation',
        label: 'Improper Counterflashing / Step Flashing Installation',
        rooftopProperty: 'improperCounterflashingStepFlashingInstallation',
      },
    ],
  },
  {
    id: 'membrane-defects',
    label: 'Membrane Defects',
    types: [
      {
        id: 'seam-failures-split-seams',
        label: 'Seam Failures / Split Seams',
        rooftopProperty: 'seamFailuresSplitSeams',
      },
      {
        id: 'membrane-shrinkage',
        label: 'Membrane Shrinkage',
        rooftopProperty: 'membraneShrinkage',
      },
      { id: 'fishmouths', label: 'Fishmouths', rooftopProperty: 'fishmouths' },
      { id: 'tentings', label: 'Tentings', rooftopProperty: 'tentings' },
      {
        id: 'open-terminations-edges',
        label: 'Open Terminations / Edges',
        rooftopProperty: 'openTerminationsEdges',
      },
      {
        id: 'thermal-bridging-insulation-exposure',
        label: 'Thermal Bridging / Insulation Exposure',
        rooftopProperty: 'thermalBridgingInsulationExposure',
      },
    ],
  },
  {
    id: 'uv-and-environmental-degradation',
    label: 'UV and Environmental Degradation',
    types: [
      {
        id: 'uv-damage-brittleness',
        label: 'UV Damage / Brittleness',
        rooftopProperty: 'uvDamageBrittleness',
      },
      {
        id: 'surface-chalkiness',
        label: 'Surface Chalkiness',
        rooftopProperty: 'surfaceChalkiness',
      },
      {
        id: 'color-fading-discoloration',
        label: 'Color Fading / Discoloration',
        rooftopProperty: 'colorFadingDiscoloration',
      },
      {
        id: 'surface-erosion',
        label: 'Surface Erosion',
        rooftopProperty: 'surfaceErosion',
      },
      {
        id: 'wind-uplift-wind-scour',
        label: 'Wind Uplift / Wind Scour',
        rooftopProperty: 'windUpliftWindScour',
      },
      {
        id: 'hail-damage-impact-craters',
        label: 'Hail Damage / Impact Craters',
        rooftopProperty: 'hailDamageImpactCraters',
      },
      {
        id: 'tree-limb-or-debris-damage',
        label: 'Tree Limb or Debris Damage',
        rooftopProperty: 'treeLimbOrDebrisDamage',
      },
      {
        id: 'construction-maintenance-debris',
        label: 'Construction/Maintenance Debris',
        rooftopProperty: 'constructionMaintenanceDebris',
      },
    ],
  },
  {
    id: 'drainage-issues',
    label: 'Drainage Issues',
    types: [
      {
        id: 'clogged-roof-drains-scuppers-gutters',
        label: 'Clogged Roof Drains / Scuppers / Gutters',
        rooftopProperty: 'cloggedRoofDrainsScuppersGutters',
      },
      {
        id: 'blocked-overflow-outlets',
        label: 'Blocked Overflow Outlets',
        rooftopProperty: 'blockedOverflowOutlets',
      },
      {
        id: 'improper-drainage-slope',
        label: 'Improper Drainage Slope',
        rooftopProperty: 'improperDrainageSlope',
      },
      {
        id: 'overflow-or-backup-evidence',
        label: 'Overflow or Backup Evidence',
        rooftopProperty: 'overflowOrBackupEvidence',
      },
    ],
  },
  {
    id: 'roof-penetrations-and-fixtures',
    label: 'Roof Penetrations & Fixtures',
    types: [
      {
        id: 'defective-pipe-boots-flashing-collars',
        label: 'Defective Pipe Boots / Flashing Collars',
        rooftopProperty: 'defectivePipeBootsFlashingCollars',
      },
      {
        id: 'leaky-skylight-perimeters',
        label: 'Leaky Skylight Perimeters',
        rooftopProperty: 'leakySkylightPerimeters',
      },
      {
        id: 'improper-hvac-unit-mounting',
        label: 'Improper HVAC Unit Mounting',
        rooftopProperty: 'improperHvacUnitMounting',
      },
      {
        id: 'corroded-mechanical-supports-or-rails',
        label: 'Corroded Mechanical Supports or Rails',
        rooftopProperty: 'corrodedMechanicalSupportsOrRails',
      },
      {
        id: 'debris-accumulation-around-penetrations',
        label: 'Debris Accumulation Around Penetrations',
        rooftopProperty: 'debrisAccumulationAroundPenetrations',
      },
    ],
  },
  {
    id: 'perimeter-and-edge-defects',
    label: 'Perimeter & Edge Defects',
    types: [
      {
        id: 'loose-gravel-stops-edge-flashing',
        label: 'Loose Gravel Stops / Edge Flashing',
        rooftopProperty: 'looseGravelStopsEdgeFlashing',
      },
      {
        id: 'parapet-wall-deterioration',
        label: 'Parapet Wall Deterioration',
        rooftopProperty: 'parapetWallDeterioration',
      },
      {
        id: 'water-intrusion-at-copings-caps',
        label: 'Water Intrusion at Copings / Caps',
        rooftopProperty: 'waterIntrusionAtCopingsCaps',
      },
      {
        id: 'gaps-at-expansion-joints',
        label: 'Gaps at Expansion Joints',
        rooftopProperty: 'gapsAtExpansionJoints',
      },
    ],
  },
  {
    id: 'vegetative-biological-growth',
    label: 'Vegetative / Biological Growth',
    types: [
      {
        id: 'moss-or-algae-growth',
        label: 'Moss or Algae Growth',
        rooftopProperty: 'mossOrAlgaeGrowth',
      },
      {
        id: 'lichen-mold-stains',
        label: 'Lichen / Mold Stains',
        rooftopProperty: 'lichenMoldStains',
      },
      {
        id: 'root-penetration',
        label: 'Root Penetration',
        rooftopProperty: 'rootPenetration',
      },
      {
        id: 'bird-or-pest-nesting-damage',
        label: 'Bird or Pest Nesting Damage',
        rooftopProperty: 'birdOrPestNestingDamage',
      },
      {
        id: 'vegetative-debris',
        label: 'Vegetative Debris',
        rooftopProperty: 'vegetativeDebris',
      },
    ],
  },
]

export const getAllRooftopDamageTypes = (): RooftopDamageType[] => {
  return rooftopDamageCategories.flatMap((category) => category.types)
}
